import { Component } from '@theme/component';

/**
 * Barra inferior do celular. "Categorias" abre o drawer do header da Chaya; com o header do Horizon,
 * clica no <summary> nativo (HeaderDrawer.open() sozinho não abre o <details>).
 * @extends {Component<{}>}
 */
class CharmBottomNav extends Component {
  openMenu() {
    const header = document.querySelector('charm-header-component');
    if (header && 'openMenu' in header) return header.openMenu();
    document.querySelector('#header-component .header__icon--summary')?.click();
  }
}

if (!customElements.get('charm-bottom-nav-component')) {
  customElements.define('charm-bottom-nav-component', CharmBottomNav);
}
